<template>
  <div>
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <div v-if="person" class="person-single max-width-reader mx-auto p2" id="person">
      <div class="center">
        <img v-if="hasImage" class="greyscale" :src="person.acf.details.image.sizes.thumbnail" />
        <div>
          <h1 class="caps mb0 mt1" v-text="person.title.rendered" />
          <h2 class="red mb0 fs-s" v-text="person.acf.details.role" />
          <div v-if="person.acf.contact">
            <ul class="contact-items list-reset border-bottom mt3 mb3">
              <li class="clearfix border-top py1 fs-s mono left-align flex items-center" v-for="(item, index) in person.acf.contact" :key="index">
                <div class="col col-4 caps">{{ item.type }}</div>
                <div v-if="item.type === 'pgp-key'" class="col col-8 right-align">
                  <button class="btn caps mono inline-block" :data-clipboard-text="item.content">
                      <span v-if="!copied">Copy PGP Key</span>
                      <span v-else>Copied to clipboard</span>
                  </button>
                </div>
                <div v-else-if="item.type === 'twitter'" class="col col-8 right-align">
                  <a class="hover-red" :href="`https://twitter.com/${item.content}`" target="_blank">@{{ item.content }}</a>
                </div>
                <div v-else class="col col-8 right-align">
                  {{ item.content }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="description" v-html="person.acf.description" />

      <div v-if="person && person.related">
        <ul v-for="(type, index) in relatedTypes" :ref="`related-${type}`" v-if="getRelatedByType(type).length" class="related-list list-reset border-top my3" :key="`outer-${index}`">
          <li class="red capitalize py2">{{ type === 'press' ? 'press' : type+'s' }}</li>
          <li class="pb1" v-for="(item, index) in getRelatedByType(type)" :key="index">
            <router-link v-if="item.post_type !== 'press'" class="hover-red" :to="getLink(item)">{{ item.title }}</router-link>
            <a v-else class="hover-red" target="_blank" :href="item.link">{{ item.title }}</a>
            <span @click="openRelated(type)" class="expand-link block m0 mt1 py1 hover-red pointer" v-if="index === relatedLimit && getRelatedByType(type).length !== relatedLimit + 1">↓ ({{ getRelatedByType(type).length - relatedLimit - 1 }} more)</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import SubMenu from '@/components/SubMenu'
import clip from 'clipboard'

export default {

  name: 'TeamDetail',

  data () {
    return {
      person: false,
      showContact: false,
      relatedLimit: 4,
      relatedTypes: [
        'investigation',
        'exhibition',
        'publication',
        'event',
        'press'
      ],
      clipboard: false,
      copied: false
    }
  },

  metaInfo () {
    return {
      title: this.name || 'Loading...',
      meta: [
        { name: 'og:title', content: this.name },
        { name: 'twitter:title', content: this.name },
        { name: 'og:image', content: this.profileImage },
        { name: 'twitter:image', content: this.profileImage },
        { name: 'og:url', content: `${window.location.origin}/${this.$route.fullPath}` },
        { name: 'og:type', content: 'profile' },
        { name: 'og:first_name', content: this.firstName },
        { name: 'og:last_name', content: this.lastName },
        { name: 'og:description', content: this.shortDescription },
        { name: 'twitter:description', content: this.shortDescription }
      ]
    }
  },

  components: {
    SubMenu
  },

  computed: {
    hasImage: function () {
      return this.person.acf.details.image
    },
    profileImage: function () {
      if (this.person) {
        return this.person.acf.details.image.link
      }
    },
    name: function () {
      if (this.person) {
        return this.person.title.rendered
      } else {
        return false
      }
    },
    firstName: function () {
      if (this.person) {
        return this.person.acf.details.first_name
      } else {
        return false
      }
    },
    lastName: function () {
      if (this.person) {
        return this.person.acf.details.last_name
      } else {
        return false
      }
    },
    shortDescription: function () {
      if (this.person) {
        return this.person.acf.short_description
      } else {
        return false
      }
    }
  },

  methods: {
    clip,
    getTeamMember: async function () {
      try {
        // TODO: this is jank CORS api crap
        let response = await Axios.get(`//content.forensic-architecture.org/wp-json/wp/v2/person?slug=${this.$route.params.slug}`)
        let data = response.data[0]
        data.related = false
        this.person = data
        this.getRelatedItems(data.id)
        this.clipboard = new clip('.btn')

        this.clipboard.on('success', (e) => {
          this.copied = true
          e.clearSelection()
        })

        return true
      } catch (error) {
        return error
      }
    },
    getRelatedItems: async function (id) {
      try {
        // TODO: this is jank CORS api crap
        let response = await Axios.get(`//content.forensic-architecture.org/wp-json/fa/v1/related/${id}`)
        this.person.related = response.data
        return true
      } catch (error) {
        return error
      }
    },
    getRelatedByType: function (type) {
      return this.person.related.filter(x => {
        return x.post_type === type
      }).sort((a,b) => {
        if (a.date > b.date) {
          return -1
        } else {
          return 1
        }
      })
    },
    getLink: (item) => {
      if (item.post_type === 'investigation') {
        return { name: 'Investigation', params: {'investigationSlug': item.slug }}
      } else if (item.post_type === 'exhibition') {
        return { name: 'Exhibition', params: {'slug': item.slug }}
      } else if (item.post_type === 'event') {
        return { name: 'Events', params: {'slug': item.slug }}
      } else if (item.post_type === 'news') {
        return { name: 'News', params: {'slug': item.slug }}
      } else if (item.post_type === 'publication') {
        return { name: 'Publications', hash: `#${item.slug}` }
      }
    },
    openRelated: function (type) {
      this.$refs[`related-${type}`][0].classList.add('open')
    }
  },

  mounted () {
    this.getTeamMember()
  },

  watch: {
    '$route' () {
      this.getTeamMember()
    }
  }

}
</script>

<style lang="css" scoped>


  .key-box {
    background: rgba(255,0,0,0.1);
    border: 1px var(--red) dotted;
  }
  .contact-items {
    span.contact-badge {
      border: 1px solid red;
      padding: 0.25em 1em;
      border-radius: 3px;
      background: rgba(255,0,0,0.1);
    }
  }
  >>>.sub-menu {
    .router-link-active {
      font-style: italic;
      text-transform: capitalize;
      border-bottom: 1px solid var(--red);
    }
  }
  img {
    width: 100px;
    height: 100px;
    border-radius: 60%;
  }

  .description {
    >>> a {
      border-bottom: 1px solid var(--red);
    }
  }

  .related-list {
    li:nth-child(n+7) {
      display: none;
    }

    &.open {
      .expand-link {
        display: none;
      }
      li:nth-child(n+7) {
        display: block;
      }
    }
  }

  .fade {
    position: relative;
    max-height: calc(var(--line-height-reader) * 5.94);
    overflow: hidden;

    >>> p {
      margin-top: var(--line-height-reader);
      margin-bottom: 0;
    }
  }
  .fade:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 70%;
    height: 1.15em;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
  }

  button {
    background: var(--col-light);
    display: inline-block;
    padding: 0.3em 0.5em;
    border: 1px solid var(--black);
    text-align: center;
    border-radius: 4px;
    color: var(--red);
    border-color: var(--red);
    cursor: pointer;

    &:hover {
      color: var(--col-light);
      background: var(--red);
    }
  }
</style>
